module.exports = __webpack_public_path__ + "static/img/app@2x.63b27db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/app@2x.png
// module id = Nc9n
// module chunks = 2